import{useLayoutEffect as e,useEffect as o}from"react";var d="undefined"!=typeof window&&void 0!==window.document&&void 0!==window.document.createElement,n=d?e:o;export{d as isDomEnvironment,n as useIsomorphicLayoutEffect};
